import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { waLink } from "../lib/execora";

export const Concierge = () => {
  return (
    <section
      id="concierge"
      data-testid="concierge-section"
      className="relative py-16 md:py-20 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-[#84cc15] via-[#84cc15] to-[#65a30d] p-8 sm:p-12 lg:p-16">
          <div className="absolute inset-0 bg-grid opacity-[0.12] pointer-events-none" aria-hidden="true" />
          <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-white/20 blur-3xl" aria-hidden="true" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900 text-white text-xs font-medium tracking-wide">
                <Sparkles className="h-3.5 w-3.5 text-[#84cc15]" strokeWidth={2.2} />
                Concierge
              </div>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.05]">
                We handle any task. <br className="hidden sm:block" />
                Pay us by the hour.
              </h2>
              <p className="mt-5 max-w-xl text-slate-900/80 text-base sm:text-lg leading-relaxed">
                Stand in a queue, pick up grandma's medicines, return an Amazon package, find a good carpenter, wait for the cable guy. Anything the day throws at you — handled for{" "}
                <span className="font-semibold">₹200 per hour</span>.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <a
                href={waLink("Hi Execora, I'd like to book a Concierge task.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="concierge-cta"
                className="group inline-flex items-center gap-2 px-6 py-4 rounded-xl text-base font-semibold text-white bg-slate-900 hover:bg-slate-800 transition-colors"
              >
                Book a concierge
                <ArrowRight className="h-5 w-5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Concierge;
